module.exports = __webpack_public_path__ + "media/images/landing__leaguesTeaser-7e94e487f1b852a80e80d02a2fd997fa.png";